export default "__VITE_ASSET__$noiv6oP__"